import { Constants as MoltenConstants } from '@leverege/molten';
import { Attributes } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import FotaApi from '@leverege/api-ui-fota-management/lib/api/FotaApi';
import Fota from '@leverege/api-ui-fota-management';
import CreateFotaAttributes from '../attributes/attributes/fota/CreateFotaAttributes';
import CreateFotaRenderers from '../attributes/renderers/fota/CreateFotaRenderers';
const Types = Fota.Constants.Types;
async function createCounterAttributes(molten, blueprints) {
  const uiName = molten.getConfig('uiName');
  // disable this for not deviceManagement
  // TODO : Don't include this plugin at all if we aren't in device management ui
  if (uiName !== 'deviceManagement') {
    return;
  }
  const systemId = molten.getConfig('api/systemId');
  const api = new FotaApi({
    relationship: {
      options: {
        systemId
      }
    }
  });
  let deviceTypes;
  try {
    deviceTypes = await GlobalState.dispatch(api.getAll('deviceType'));
  } catch (err) {
    console.log('failed to create counter attributes: get all deviceTypes', err);
    return;
  }
  const hasImagineType = deviceTypes?.items?.filter(dt => Attributes.get('options.imagine.groupBlueprintId', Types.deviceType, dt) != null);
  hasImagineType.forEach(deviceType => {
    const bpId = Attributes.get('options.imagine.groupBlueprintId', Types.deviceType, deviceType);
    const blueprint = blueprints.find(bp => bp.id === bpId);
    if (blueprint) {
      CreateFotaAttributes(molten, deviceType, blueprint);
      CreateFotaRenderers(molten, deviceType, blueprint);
    }
  });
}
const FotaCountersAnalyzer = {
  type: MoltenConstants.BLUEPRINTS_PROCESSOR,
  id: 'recovr.FotaCountersAnalyzer',
  processBlueprints: createCounterAttributes
};
export default FotaCountersAnalyzer;